import React, { useEffect, } from 'react';
import { useDispatch } from 'react-redux';
import { reloadChatbot } from '../../actions';
import { useChatbotInitialMessage } from '../../hooks';
import { useCurrentScreen } from '../../hooks/useCurrentScreen';
import { useSelectChatbot } from '../../selectors';
import { OnuScreens } from '../../types';
import { addMessageToState, setInitialChatBotMessageToState } from './utils';
const ActionProvider = ({ createChatBotMessage, setState, children, state, }) => {
    const screen = useCurrentScreen() ?? OnuScreens.DASHBOARD;
    const dispatch = useDispatch();
    const initialMessage = useChatbotInitialMessage(screen);
    const { clearHistory } = useSelectChatbot();
    const initialChatBotMessage = createChatBotMessage(initialMessage, {
        widget: 'textButton',
        payload: { screen },
    });
    useEffect(() => {
        if (clearHistory) {
            setInitialChatBotMessageToState(setState, initialChatBotMessage);
            dispatch(reloadChatbot());
        }
    }, [clearHistory]);
    useEffect(() => {
        if (state.messages.length === 1) {
            setInitialChatBotMessageToState(setState, initialChatBotMessage);
        }
    }, [screen, state.messages.length]);
    const handleMessage = async (message) => {
        if (message.length > 0) {
            addMessageToState(setState, createChatBotMessage('', {
                widget: 'chatbotAnswer',
                payload: { message },
            }));
        }
    };
    return (React.createElement(React.Fragment, null, React.Children.map(children, child => React.cloneElement(child, {
        actions: {
            handleMessage,
        },
    }))));
};
export default ActionProvider;
